<template>
    <div class="wiki-page-wrapper">
        <LeftBanner @langSelect="langSelect" />
        <div class="right-banner">
            <div align="right">
                <el-button type="primary" round @click="bubbleBtnClick">{{ $t("zhiji.wiki.bubbleBtn") }}</el-button>
                <el-button type="primary" round @click="hotSearchBtnClick">{{ $t("zhiji.wiki.hotSearchBtn") }}</el-button>
            </div>
            <MainPush :lang="currentLang" />
            <BlockManage :lang="currentLang" />
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import LeftBanner from "./components/LeftBanner";
import MainPush from "./components/MainPush";
import BlockManage from "./components/BlockManage";
import BubbleSettingModal from "./components/BubbleSettingModal";
import HotSearchModal from "./components/HotSearchModal";

export default {
    name: "WikiPage",
    components: {
        LeftBanner,
        MainPush,
        BlockManage,
        BubbleSettingModal,
        HotSearchModal
    },
    data() {
        return {
            currentLang: "en"
        };
    },
    methods: {
        langSelect(lang) {
            this.currentLang = lang;
        },
        bubbleBtnClick() {
             this.zhiji
                .requestByServiceName("getBubbleSetting", {
                    lang: this.currentLang,
                })
                .then((result) => {
                    this.$store.dispatch("zhiji/showModal", {
                        type: BubbleSettingModal,
                        data: {
                            lang: this.currentLang,
                            formData: result || {}
                        }
                    });
                });
        },
        hotSearchBtnClick() {
            this.zhiji
                .requestByServiceName("getHotSearch", {
                    lang: this.currentLang,
                })
                .then((result) => {
                    this.$store.dispatch("zhiji/showModal", {
                        type: HotSearchModal,
                        data: {
                            lang: this.currentLang,
                            formData: result || {}
                        }
                    });
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.wiki-page-wrapper {
    display: flex;
    flex: 1;
    width: 100%;
    height: 100%;

    .right-banner {
        flex: 1;
        background: #f2f7fb;
        height: 100%;
        padding: 16px;
        box-sizing: border-box;
        overflow:auto;
    }
}
</style>
